import styled, { css } from 'styled-components';
import { FONTS, COLORS, SIZE } from '@app/src/ui';
import { Button } from '@app/src/common/Button';

const FONT_RESPONSIVE: string = '13px';

export const Wrapper = styled.div`
  box-sizing: border-box;
  padding: 15px 15px 0;
  user-select: none;
  width: 320px;
  margin: 0 auto;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    width: 100%;
    padding: 40px 40px 0;
  }
`;

export const Title = styled.h2`
  font-family: ${FONTS.ARISTOTELICA};
  margin-bottom: 25px;
  font-size: 22px;
  line-height: 24px;
  color: ${COLORS.BLACK};
  font-weight: 500;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 26px;
    line-height: 29px;
  }
`;

export const PriceConceptWraper = styled.div`
  width: 100%;
  margin-bottom: 10px;
`;

export const Information = styled.div`
  display: block;
  font-family: ${FONTS.OPEN_SANS};
  font-size: ${FONT_RESPONSIVE};
  line-height: 16px;
  color: #757575;
  margin: 15px 0 26px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 14px;
    line-height: 19px;
    margin: 26px 0;
  }
`;

export const ButtonActionsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  width: 100%;
`;

const buttonStyle = css`
  font-weight: 600;
  font-family: ${FONTS.OPEN_SANS};
`;

export const ButtonPrevWrapper = styled(Button)`
  ${buttonStyle};
  font-size: 12px;

  span {
    text-align: left;
  }

  svg {
    flex: 0 0 auto;
    margin-right: 6px;
  }
`;

export const ButtonNextWrapper = styled(Button)`
  ${buttonStyle}
  font-size: 14px;

  svg {
    transform: rotate(180deg);
    margin-left: 6px;
  }
`;

export const Closure = styled.span`
  display: block;
  color: ${COLORS.BLACK};
  margin-bottom: 4px;
`;

export const ClosureInfo = styled.p`
  margin-bottom: 2px;
`;

export const Footer = styled.div`
  position: sticky;
  bottom: 0;
  width: 100%;
  padding: 15px;
  background-color: white;
  margin-top: auto;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    padding: 15px 40px 40px;
  }
`;
